/**
 * SpeedmasterCore.Favicon.js — Modern favicon injection
 *
 * Removes the broken SCS default favicon link and injects modern tags:
 *   - favicon.ico (48×48 legacy fallback)
 *   - favicon.svg (primary — scalable, dark mode ready)
 *   - favicon-96x96.png (Google Search)
 *   - apple-touch-icon.png (180×180 iOS home screen)
 *   - site.webmanifest (Android/PWA icons)
 *   - apple-mobile-web-app-title meta tag
 *
 * Base path configurable via speedmaster.FaviconBasePath (default: /images).
 * Files must be uploaded to File Cabinet → Web Site Hosting Files →
 * Live Hosting Files → images/
 */
define('SpeedmasterCore.Favicon', [
    'SC.Configuration'
], function(Configuration) {
    'use strict';

    return {
        /**
         * Inject modern favicon <link> tags into <head>.
         * Call once from mountToApp in any scope entry point.
         */
        inject: function inject() {
            var basePath = Configuration.get('speedmaster.FaviconBasePath') || '/images';
            var head = document.head || document.getElementsByTagName('head')[0];

            if (!head) { return; }

            // Remove existing broken SCS favicon link(s)
            var existing = head.querySelectorAll('link[rel="shortcut icon"], link[rel="icon"]');
            for (var i = 0; i < existing.length; i++) {
                head.removeChild(existing[i]);
            }

            // Modern favicon tags
            var tags = [
                { rel: 'icon', href: basePath + '/favicon.ico', sizes: '48x48' },
                { rel: 'icon', href: basePath + '/favicon.svg', type: 'image/svg+xml' },
                { rel: 'icon', href: basePath + '/favicon-96x96.png', type: 'image/png', sizes: '96x96' },
                { rel: 'apple-touch-icon', href: basePath + '/apple-touch-icon.png', sizes: '180x180' },
                { rel: 'manifest', href: basePath + '/site.webmanifest' }
            ];

            for (var j = 0; j < tags.length; j++) {
                var link = document.createElement('link');
                link.rel = tags[j].rel;
                link.href = tags[j].href;
                if (tags[j].sizes) { link.setAttribute('sizes', tags[j].sizes); }
                if (tags[j].type) { link.type = tags[j].type; }
                head.appendChild(link);
            }

            // Apple mobile web app title
            if (!head.querySelector('meta[name="apple-mobile-web-app-title"]')) {
                var meta = document.createElement('meta');
                meta.name = 'apple-mobile-web-app-title';
                meta.content = 'Speedmaster';
                head.appendChild(meta);
            }
        }
    };
});
